module.exports = __webpack_public_path__ + "static/media/10.03a621d4.png";